<div class="row">
  <div class="columns">
    <h4 class="mos-u-display--inline-block mos-u-spacer--margin-top-sm">Details</h4>
    <div *ngIf="!(isMobile$ | async)">
      <div class="row profile-image-row profile-detail-row">
        <div class="column small-12 medium-3 mos-u-text-right profile-detail-label-column">
          <label class="mos-u-spacer--margin-bottom-sm  user-detail-label">Profile
            image:</label>
        </div>
        <div class="column small-12 medium-9 value-column user-detail-body profile-detail-value-column">
          <atlas-avatar *ngIf="!((user$ | async)?.profileImageId)" [imgAlt]="'Profile Image'" size="large">
            {{((user$ | async)?.initials)}}
          </atlas-avatar>
          <atlas-avatar *ngIf="(user$ | async)?.profileImageId && !imageLoadFailed" [imgSrc]="imageUrl"
            [imgAlt]="'Profile Image'" size="large">
          </atlas-avatar>
          <atlas-avatar *ngIf="(user$ | async)?.profileImageId && imageLoadFailed" [imgAlt]="'Profile Image'"
            size="large">
            {{((user$ | async)?.initials)}}
          </atlas-avatar>



          <div class="button-group">
            <input type="file" #file accept="image/*" (change)="setProfileImage($event)" />
            <button class="custom-file-upload" (click)="file.click()">
              Change Photo
            </button>
            <button id="button-admin-remove-photo" class="custom-file-upload" (click)="removeImage()">
              Remove Photo
            </button>
          </div>
        </div>
      </div>
      <div class="row description-row profile-detail-row">
        <div class="column small-12 medium-3 profile-detail-label-column"></div>
        <div class="column small-12 medium-9 profile-detail-value-column">
          <div class="imageDesc user-detail-label">
            Please upload photos in *.jpeg, *.jpg, *.png format and max size of 1 mb
          </div>
        </div>
      </div>
    </div>

    <div class="row profile-detail-row">
      <div class="column small-12 medium-3 mos-u-text-right profile-detail-label-column">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label">Username/Email:</label>
      </div>
      <div class="column small-12 medium-9 profile-detail-value-column">
        <div class="mos-u-spacer--margin-bottom-sm user-detail-body">{{ (user$ | async)?.username }}
        </div>
      </div>
    </div>

    <div class="row profile-detail-row">
      <div class="column small-12 medium-3 mos-u-text-right profile-detail-label-column">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label">Full Name:</label>
      </div>
      <div class="column small-12 medium-9 profile-detail-value-column">
        <div class="mos-u-spacer--margin-bottom-sm user-detail-body">{{ (user$ | async)?.fullName }}
        </div>
      </div>
    </div>


    <div class="row profile-detail-row">
      <div class="column small-12 medium-3 mos-u-text-right profile-detail-label-column">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label">Phone Number:</label>
      </div>
      <div class="column small-12 medium-9 profile-detail-value-column">
        <div class="mos-u-spacer--margin-bottom-sm user-detail-body">{{ (user$ | async)?.phone }}</div>
      </div>
    </div>

    <div class="row profile-detail-row">
      <div class="column small-12 medium-3 mos-u-text-right profile-detail-label-column">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label">Organisation:</label>
      </div>
      <div class="column small-12 medium-9 profile-detail-value-column">
        <div class="mos-u-spacer--margin-bottom-sm user-detail-body">{{ (user$ | async)?.org.name }}
        </div>
      </div>
    </div>

    <div class="row profile-detail-row">
      <div class="column small-12 medium-3 mos-u-text-right profile-detail-label-column">
        <label class="mos-u-spacer--margin-bottom-sm user-detail-label">Country:</label>
      </div>
      <div class="column small-12 medium-9 user-detail-body profile-detail-value-column">
        <div class="mos-u-spacer--margin-bottom-sm  country-display">
          <atlas-icon class="country-flag" *ngIf="(country$ | async)?.value === 'au'" icon="australia"
            collection="flags"></atlas-icon>
          <atlas-icon class="country-flag" *ngIf="(country$ | async)?.value === 'nz'" icon="new-zealand"
            collection="flags"></atlas-icon>
          <span class="country-name user-detail-body">{{ (country$ | async)?.name }}</span>
        </div>
      </div>
    </div>
  </div>
</div>